module.exports = __webpack_public_path__ + "img/utiliteGant.04f01d5c.jpg";